import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Typography } from '@mui/material'

import { useAllCreativesList } from '../../hooks/useAllCreativesList'
import { useUAInsightsNavigation } from '../../hooks/useUAInsightsNavigation'
import { CreativeAdsTable } from '../CreativeAdsTable/CreativeAdsTable'
import { TableSkeleton } from '../TableSkeleton/TableSkeleton'
import { UAInsightsDialog } from '../UAInsightsDialog/UAInsightsDialog'

/**
 * Drill-down dialog reached from the "Total Creatives" summary card. Lists
 * every creative ad in the current network scope and reuses `CreativeAdsTable`
 * so each row keeps its game / ad / network drill-through behaviour.
 */
export const AllCreativesDialog: FC = () => {
  const { t } = useTranslation('ua-insights')
  const { params, close, canGoBack, goBack } = useUAInsightsNavigation()
  const open = params.dialog === 'all-creatives'
  const { data, isLoading, isError, refetch } = useAllCreativesList(open)

  return (
    <UAInsightsDialog
      open={open}
      onClose={close}
      title={t('all_creatives_title')}
      canGoBack={canGoBack}
      onGoBack={goBack}
      showNetworkSelector
      hasData={!!data}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      loadingPlaceholder={<TableSkeleton rows={10} columns={6} />}
      notFoundFallback={
        <Typography variant="body2" color="text.secondary">
          {t('no_ads')}
        </Typography>
      }
    >
      {data && <CreativeAdsTable rows={data.creatives} />}
    </UAInsightsDialog>
  )
}
